import { Reducer, useEffect, useReducer } from 'react';
import {
  CompletedInspectionsByTemplateFilters,
  InspectionChart,
} from 'shared/types/analytics';
import { useInspectionTemplates } from 'store/inspection';
import { extractFiltersValues } from 'charts/common/filterValues';
import { useInspectionChartDependencies } from 'charts/common/useInspectionChartDependencies';
import { isEmptyArray } from 'shared/utils/array';
import { createFiltersForView } from './createFilters';
import { useChartFiltersPersistence } from '../common/useChartFiltersPersistence';
import { defaultValues } from './defaultFilters';
import { FilterAction } from './types';
import { filtersReducer } from 'charts/common/filtersReducer';
import { useFiltersActions } from 'charts/common/filtersActions';

export function useCompletedInspectionsByTemplateFilters():
  | CompletedInspectionsByTemplateFilters
  | undefined {
  const { loading: inspectionTemplatesLoading } = useInspectionTemplates();

  const [filters, dispatchFilters] = useReducer<
    Reducer<
      CompletedInspectionsByTemplateFilters | undefined,
      FilterAction
    >
  >(filtersReducer, undefined);
  const { rewriteFilters, ...filtersActions } =
    useFiltersActions(dispatchFilters);

  const { savedFilters } = useChartFiltersPersistence(InspectionChart.completedInspectionsByTemplate, filters, defaultValues);

  const chartDependencies = useInspectionChartDependencies(savedFilters);
  // The chart counts inspections by template: its filters wait for the templates.
  const dependencies = inspectionTemplatesLoading ? undefined : chartDependencies;

  useEffect(() => {
    if (!dependencies || isEmptyArray(dependencies.processes)) return;

    const filterValues = extractFiltersValues(filters) ?? dependencies.filters;
    rewriteFilters(createFiltersForView({ ...dependencies, filters: filterValues }, filtersActions));
  }, [dependencies, rewriteFilters]);

  return filters;
}
